import { createRoot } from "react-dom/client";

import App from "./App";
import "./styles.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

// Deliberately NOT wrapped in <StrictMode>. StrictMode mounts, unmounts and
// remounts every component in development, which runs the cleanup in
// `useConversation` — and that cleanup calls `leave()` and `destroy()` on the
// live room. The call joins, the microphone publishes, and the send transport
// is then torn down a moment later, so the platform receives no audio, never
// detects a turn, and the avatar sits there silently. Nothing in the UI says
// anything is wrong; she simply stops responding after the greeting.
createRoot(container).render(<App />);
